import React from 'react';
import { Link } from 'react-router-dom';
import dryFruitImage from '../assets/images/h4.gif';
import '../styles/Carousel.css';

const Carousel = () => {
  return (
    <div className="luxury-carousel">
      <div className="carousel-content">
        <div className="text-wrapper">
          <h1 className="collection-title">
            <span className="year-end">NATURAL</span>
            <span className="year">POWER SURGE</span>
          </h1>

          <div className="subtitle-wrapper">
            <div className="deco-line"></div>
            <p className="essentials-text">
              {/* Fuel your body with next-gen herbal vitality */}
              Elevate daily energy with modern herbal vitality
            </p>
            <div className="deco-line"></div>
          </div>

          <div className="btn-container">
            <Link
              to="/all-products"
              className="shop-btn men-btn"
            >
              SHOP ALL
              <span className="hover-bar"></span>
            </Link>

          </div>
        </div>

        <img
          src={dryFruitImage}
          alt="A selection of premium dry fruits and nuts"
          className="hero-image"
          onClick={() => window.location.href = '/all-products'}
        />
      </div>
    </div>
  );
};

export default Carousel;